import { toast } from 'react-toastify';

const getUseridInfoService = (actionCallback, userId, history) => {
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    fetch(baseUrl + "/rest/card/detailsByUserId/" + userId, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
        })
    })
        .then(res => {
            if (res.status === 200) {
                if (localStorage.getItem('userIdToast') === 'first') {
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('userIdToast', 'second')
                }
                res.json().then(json => {
                    
                  if(Array.isArray(json)) {
                    actionCallback(json, "success")
                    if(history !== undefined){ history.push('/useriddetails') }
                  }
                  else {
                    localStorage.setItem('cardRefNumber',json.cardReferenceId)
                    actionCallback(json, "success")
                    if(history !== undefined){ history.push('/carddetails') }
                  }
                })
            } 
            else if(res.status === 401){
                actionCallback("401", "sessionout")
                this.props.history.push('/SessionOut')
            }
            else {
                if (localStorage.getItem('userIdToast') === 'first') {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                // localStorage.setItem('userIdToast', 'second')
            }
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getUseridInfoService;


// WEBPACK FOOTER //
// ./src/services/components/userid_info.jsx